<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <el-row>
            <el-col :span="12">
                <div style="font-size: 18px;padding: 20px;padding-top: 28px;font-weight: bold;">
                    辖区变更审批
                </div>
            </el-col>
            <el-col :span="12">
                <div style="padding: 20px;padding-top: 28px;float: right" class="people">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="管理辖区">
                            <el-select v-model="form.TerritoryList" placeholder="请选择" @change="xuanze">
                                <el-option
                                        v-for="item in TerritoryList"
                                        :key="item.territory_id"
                                        :label="item.territory_name"
                                        :value="item.territory_id"
                                        :disabled="role=='staff'"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <div  class="box">
            <div class="zuo" style="position: relative;left: 20px">
                <img src="../../assets/images/zuo.png" alt="">
            </div>
            <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper">

                    <div class="swiper-slide" v-for="item in array"  :style="{backgroundColor:item.isSelect?'#ECF3FC':'#fff',borderColor:item.isSelect?'#4A90E2':'#ededed'}">
                        <div @click="selectBack(item)" >
                            <el-row style="padding: 10px" v-if="item.territory_code !==''">
                                <el-col :span="24"><span style="color: #4D586D;font-size: 14px">{{item.territory_name}}（{{item.territory_code}}）</span></el-col>
                            </el-row>
                            <el-row style="padding: 10px" v-else-if="item.territory_code ==''">
                                <el-col :span="24"><span style="color: #4D586D;font-size: 14px">{{item.territory_name}}</span></el-col>
                            </el-row>


                            <el-row style="padding:0 10px" v-if="item.alias!==null && item.title!==null">
                                <el-col :span="4"><span style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 11px;border-radius:3px">{{item.alias}}</span></el-col>
                                <el-col :span="20"><span style="color: #B0B5B9;font-size: 9px">职务：{{item.title}} </span></el-col>
                            </el-row>


                            <el-row style="padding:0 10px;height: 16px" v-else-if="item.alias==null && item.title==null">
                                <el-col :span="4" style="color: #fff"></el-col>
                                <el-col :span="20" style="color: #fff"></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px" v-if="clientObj.showInstitution">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">医疗机构</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已有机构：
                                    <span style="color: #81b1ea">{{item.institution_num}}家</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span
                                        style="color: #81b1ea">
                                    {{parseInt(item.institution_enrollment_num) === 0 ? '无' :
                                    item.institution_enrollment_num + '条'}}
                                </span> </span></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px" v-if="clientObj.showStore">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">零售终端</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已有门店：
                                    <span style="color: #81b1ea">{{item.retailstore_num}}家</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span
                                        style="color: #81b1ea">
                                     {{parseInt(item.retailstore_enrollment_num) === 0 ? '无' :
                                    item.retailstore_enrollment_num + '条'}}
                                </span> </span></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px" v-if="clientObj.showDistributor">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">分销客户</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已有经销商：
                                    <span style="color: #81b1ea">{{item.distributor_num}}家</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span
                                        style="color: #81b1ea">
                                      {{parseInt(item.distributor_enrollment_num) === 0 ? '无' :
                                    item.distributor_enrollment_num + '条'}}
                                </span> </span></el-col>
                            </el-row>
                        </div>
                        <span style="position: absolute;left: 360px;top: 60px;" @click="dianji3(item)">
                                <img :src="item.isSelect?imgarr[1]:imgarr[0]" alt="">
                            </span>

                    </div>


                </div>
            </div>


            <div class="you" style="position: relative;right: 20px">
                <img src="../../assets/images/you.png" alt="">
            </div>
        </div>
        <div class="suo" style="position: relative;float: right;right: 20px;top: 10px">
            <el-checkbox v-model="checked" @change="dianji4"></el-checkbox>
            <span style="color: #4A90E2;font-size: 14px">选中以上所有终端辖区</span>
        </div>

        <el-row style="margin-top: 85px">
            <el-col :span="8"  v-if="territoryArray.length==0">
                <span style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    {{territory_name}} {{territory_code}}
                 </span>
                <span v-if="alias!=null">
                       <span style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px" >{{alias}}</span>
                    </span>
                <span v-if="alias==null">
                       <span></span>
                    </span>
            </el-col>
            <el-col :span="8"  v-if="territoryArray.length==1">
                <span style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    {{territory_name}} {{territory_code}}
                 </span>
                <span v-if="alias!=null">
                       <span style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px" >{{alias}}</span>
                    </span>
                <span v-if="alias==null">
                       <span></span>
                    </span>
            </el-col>
            <el-col :span="8"  v-if="territoryArray.length>1">
                <span style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    多个辖区
                 </span>
                <!--                <span v-if="alias!=null">-->
                <!--                       <span style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px" >{{alias}}</span>-->
                <!--                    </span>-->
                <!--                <span v-if="alias==null">-->
                <!--                       <span></span>-->
                <!--                    </span>-->
            </el-col>


            <el-col :span="8" style="text-align: center">
                <div>
                    <el-radio-group v-model="radio1" @change="fangfa">
                        <el-radio-button label="医疗机构" v-if="clientObj.showInstitution"></el-radio-button>
                        <el-radio-button label="零售终端" v-if="clientObj.showStore"></el-radio-button>
                        <el-radio-button label="分销客户" v-if="clientObj.showDistributor"></el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :span="8">
                <div style="float: right;padding-right: 20px">
                    <el-button type="success" size="small" icon="el-icon-circle-check" @click="agree"
                    :disabled="accountArray.length === 0">同意</el-button>
                    <el-button type="danger" size="small" icon="el-icon-circle-close" @click="refuse"
                    :disabled="accountArray.length === 0">拒绝</el-button>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24" style="padding:15px 20px 20px 20px">
                <div style="border: 1px dashed #ededed">

                </div>
            </el-col>
        </el-row>

        <el-row style="padding:0px 20px" v-if="radio1=='医疗机构'">
            <el-table
                    :data="tableData"
                    border
                    stripe
                    header-cell-class-name="headerStyle2"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        fixed
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="institution_name"
                        label="客户"
                        min-width="300"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="reference_name"
                        label="客户类型"
                        width="105"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        label="调整类型"
                        width="105"
                >
                    <template slot-scope="scope">
                        <div style="">
                            <span :style="{'color':scope.row.color}">
                                {{scope.row.enrollment_name}}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="comments"
                        label="申请理由"
                        min-width="200"
                >

                </el-table-column>
                <el-table-column
                        sortable
                        prop="submit_date"
                        label="提交日期"
                        width="150"
                >
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80px" class="myclass">
                    <template slot-scope="scope">
                        <div style="width: 100%;height: 100%">
                            <el-button
                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%" size="small"
                                    @click="btn(scope.row)">详情
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row style="padding:0px 20px"  v-if="radio1=='零售终端'">
            <el-table
                    :data="tableData2"
                    border
                    stripe
                    header-cell-class-name="headerStyle2"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange2"
            >
                <el-table-column
                        fixed
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        min-width="300"
                        sortable
                        prop="store_name"
                        label="客户"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="reference_name"
                        label="客户类型"
                        width="105"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        label="调整类型"
                        width="105"
                >
                    <template slot-scope="scope">
                        <div style="">
                            <span :style="{'color':scope.row.color}">
                                {{scope.row.enrollment_name}}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="comments"
                        label="申请理由"
                        min-width="200"
                >

                </el-table-column>
                <el-table-column
                        sortable
                        prop="submit_date"
                        label="提交日期"
                        width="150"
                >
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80px" class="myclass">
                    <template slot-scope="scope">
                        <el-button
                                type="warning"
                                size="mini"
                                style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                @click="btn2(scope.row)"
                        >详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row style="padding:0px 20px" v-if="radio1=='分销客户'">
            <el-table
                    :data="tableData3"
                    border
                    stripe
                    header-cell-class-name="headerStyle2"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange3"
            >
                <el-table-column
                        fixed
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="distributor_name"
                        label="客户"
                        min-width="300"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="reference_name"
                        label="客户类型"
                        width="105"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        label="调整类型"
                        width="105"
                >
                    <template slot-scope="scope">
                        <div style="">
                            <span :style="{'color':scope.row.color}">
                                {{scope.row.enrollment_name}}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="comments"
                        label="申请理由"
                        min-width="200"
                >

                </el-table-column>
                <el-table-column
                        sortable
                        prop="submit_date"
                        label="提交日期"
                        width="150"
                >
                </el-table-column>
                <el-table-column  fixed="right" label="操作" width="80px" class="myclass">
                    <template slot-scope="scope">
                        <el-button
                                type="warning"
                                size="mini"
                                style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                @click="btn3(scope.row)"
                        >详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>


        <!--机构-->
        <el-dialog
                :visible.sync="dialogVisible"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">

                                <el-button type="success" size="small" icon="el-icon-circle-check"
                                           @click="ApprovedAccount_Asingle"
                                           >同意</el-button>
                                <el-button type="danger" size="small" icon="el-icon-circle-close"
                                           @click="DeniedAccount_Asingle"
                                           >拒绝</el-button>

                            <el-button type="danger" size="small"
                                       @click="dialogVisible = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="margin-top:20px;">
                                <el-form-item label="调整类型" >
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#7ED321;"
                                        v-if="institutionsFormInfo.enrollment_type === 'ADD'">
                                        将现有机构移入辖区
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#FF9901;"
                                       v-if="institutionsFormInfo.enrollment_type === 'NEW'">
                                        在辖区内添加新的机构
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#ED3B3F;"
                                        v-if="institutionsFormInfo.enrollment_type === 'REMOVE'">
                                        将现有机构移出辖区
                                    </p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" >
                                <el-form-item label="机构名称">
                                    <p style="margin:0;padding-left: 20px;font-size: 16px;color:#4A90E2;">{{institutionsFormInfo.institution_name}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" style="font-size: 14px">
                                <el-form-item label="推广产品">
                                    <div style="padding-left: 20px">
                                        <span style="margin:0 10px 0px 0px;background: #FF9901;
                                    color: #fff;border-radius: 5px;padding: 0 10px;"
                                              v-for="(item,index) in institutionsProductList">{{item.product_name}}</span>
                                    </div>

<!--                                    <span style="margin:0 5px 5px 20px;-->
<!--                                    background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;"-->
<!--                                          v-for="(item,index) in institutionsProductList" :key="index"-->
<!--                                    >{{item.product_name}}</span>-->
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="font-size: 14px">
                                <el-form-item label="申请理由">
                                    <p style="margin:0;padding-left: 20px;color: #87909A;">{{institutionsFormInfo.comments}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-row>
                                        <el-form ref="form" disabled label-width="120px" :model="institutionsFormInfo"
                                                 style="font-size: 14px">
                                            <el-col :span="12">
                                                <el-form-item label="名称">
                                                    <el-input v-model="institutionsFormInfo.institution_name"
                                                              disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="编码">
                                                    <el-input v-model="institutionsFormInfo.institution_code" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="类别">
                                                    <el-input v-model="institutionsFormInfo.type"></el-input>
<!--                                                    <el-select v-model="institutionsFormInfo.institution_type" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsTypeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="级别">
                                                    <el-input v-model="institutionsFormInfo.grade"></el-input>
<!--                                                    <el-select v-model="institutionsFormInfo.institution_grade" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsGardeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="省份">
                                                    <el-input v-model="institutionsFormInfo.province_name"></el-input>
<!--                                                    <el-select v-model="institutionsFormInfo.province_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in ProvinceList"-->
<!--                                                                :key="item.province_id"-->
<!--                                                                :label="item.province_name"-->
<!--                                                                :value="item.province_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="城市">
                                                    <el-input v-model="institutionsFormInfo.city_name"></el-input>
<!--                                                    <el-select v-model="institutionsFormInfo.city_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in CityList"-->
<!--                                                                :key="item.city_id"-->
<!--                                                                :label="item.city_name"-->
<!--                                                                :value="item.city_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="地址">
                                                    <el-input v-model="institutionsFormInfo.address" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="联系电话">
                                                    <el-input v-model="institutionsFormInfo.telephone" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="邮政编码">
                                                    <el-input v-model="institutionsFormInfo.postcode" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="官方网址">
                                                    <el-input v-model="institutionsFormInfo.website" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="所属经销商">
                                                    <el-input
                                                            disabled
                                                            v-model="institutionsFormInfo.distributor_name">

                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="开发进度">
                                                    <el-input v-model="institutionsFormInfo.stage"></el-input>
<!--                                                    <el-select v-model="institutionsFormInfo.agreement_stage" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in AGREEMENT_STAGE"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="已进药">
                                                    <el-switch
                                                            v-model="institutionsFormInfo.agreement_signed"
                                                            active-value="T"
                                                            inactive-value="F"
                                                            active-color="#13ce66"
                                                            disabled>
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div style="height: 300px">
                                        <el-amap
                                                vid="mapDemo1"
                                                :center="center"
                                                :zoom="12"
                                                :plugin="plugin"
                                                class="amap-demo"
                                                style="position: relative;top: -63px;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centers">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form  :model="locationForm" label-width="80px">
                                            <el-form-item label="名称">
                                                <el-input v-model="locationForm.location_name" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="地址">
                                                <el-input v-model="locationForm.address" disabled></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <!-- 零售 -->
        <el-dialog
                :visible.sync="dialogVisible2"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="success" size="small" icon="el-icon-circle-check"
                                       @click="ApprovedAccount_Asingle"
                            >同意</el-button>
                            <el-button type="danger" size="small" icon="el-icon-circle-close"
                                       @click="DeniedAccount_Asingle"
                            >拒绝</el-button>
                            <el-button type="danger" size="small"
                                       @click="dialogVisible2 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="margin-top:20px;">
                                <el-form-item label="调整类型" >
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#7ED321;"
                                        v-if="retailstoreFormInfo.enrollment_type === 'ADD'">
                                        将现有门店移入辖区
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#FF9901;"
                                       v-if="retailstoreFormInfo.enrollment_type === 'NEW'">
                                        在辖区内添加新的门店
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#ED3B3F;"
                                        v-if="retailstoreFormInfo.enrollment_type === 'REMOVE'">
                                        将现有门店移出辖区
                                    </p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" >
                                <el-form-item label="机构名称">
                                    <p style="margin:0;padding-left: 20px;font-size: 16px;color:#4A90E2;">
                                        {{retailstoreFormInfo.store_name}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" style="font-size: 14px">
                                <el-form-item label="推广产品">
                                    <div style="padding-left: 20px">
                                        <span style="margin:0 10px 0px 0px;background: #FF9901;
                                    color: #fff;border-radius: 5px;padding: 0 10px;"
                                              v-for="(item,index) in retailstoreProductList">{{item.product_name}}</span>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="font-size: 14px">
                                <el-form-item label="申请理由">
                                    <p style="margin:0;padding-left: 20px;color: #87909A;">{{retailstoreFormInfo.comments}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-row>
                                        <el-form ref="form" disabled label-width="120px" :model="retailstoreFormInfo"
                                                 style="font-size: 14px">
                                            <el-col :span="12">
                                                <el-form-item label="名称">
                                                    <el-input v-model="retailstoreFormInfo.store_name"
                                                              disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="编码">
                                                    <el-input v-model="retailstoreFormInfo.store_code" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="类别">
                                                    <el-input v-model="retailstoreFormInfo.type"></el-input>
<!--                                                    <el-select v-model="retailstoreFormInfo.institution_type" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsTypeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="级别">
                                                    <el-input v-model="retailstoreFormInfo.grade"></el-input>
<!--                                                    <el-select v-model="retailstoreFormInfo.institution_grade" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsGardeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="省份">
                                                    <el-input v-model="retailstoreFormInfo.province_name"></el-input>
<!--                                                    <el-select v-model="retailstoreFormInfo.province_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in ProvinceList"-->
<!--                                                                :key="item.province_id"-->
<!--                                                                :label="item.province_name"-->
<!--                                                                :value="item.province_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="城市">
                                                    <el-input v-model="retailstoreFormInfo.city_name"></el-input>
<!--                                                    <el-select v-model="retailstoreFormInfo.city_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in CityList"-->
<!--                                                                :key="item.city_id"-->
<!--                                                                :label="item.city_name"-->
<!--                                                                :value="item.city_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="地址">
                                                    <el-input v-model="retailstoreFormInfo.address" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="联系电话">
                                                    <el-input v-model="retailstoreFormInfo.telephone" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="邮政编码">
                                                    <el-input v-model="retailstoreFormInfo.postcode" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="官方网址">
                                                    <el-input v-model="retailstoreFormInfo.website" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="所属经销商">
                                                    <el-input
                                                            disabled
                                                            v-model="retailstoreFormInfo.distributor_name">

                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="开发进度">
                                                    <el-input v-model="retailstoreFormInfo.stage"></el-input>
<!--                                                    <el-select v-model="retailstoreFormInfo.agreement_stage" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in AGREEMENT_STAGE"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="已进药">
                                                    <el-switch
                                                            v-model="retailstoreFormInfo.agreement_signed"
                                                            active-value="T"
                                                            inactive-value="F"
                                                            active-color="#13ce66"
                                                            disabled>
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo_S">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div  style="height: 300px">
                                        <el-amap
                                                vid="mapDemo2"
                                                :center="centerRetailstore"
                                                :zoom="12"
                                                :plugin="plugin"
                                                class="amap-demo"
                                                style="position: relative;top: -63px;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centersRetailstore">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form :model="locationFormRetailstore" label-width="80px">
                                            <el-form-item label="名称">
                                                <el-input v-model="locationFormRetailstore.location_name" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="地址">
                                                <el-input v-model="locationFormRetailstore.address" disabled></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <!-- 分销 -->
        <el-dialog
                :visible.sync="dialogVisible3"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">辖区调整申请
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="success" size="small" icon="el-icon-circle-check"
                                       @click="ApprovedAccount_Asingle"
                            >同意</el-button>
                            <el-button type="danger" size="small" icon="el-icon-circle-close"
                                       @click="DeniedAccount_Asingle"
                            >拒绝</el-button>
                            <el-button type="danger" size="small"
                                       @click="dialogVisible3 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" style="margin-top: 20px;">
                    <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 100%;height: 270px;margin:20px auto;">
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="margin-top:20px;">
                                <el-form-item label="调整类型" >
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#7ED321;"
                                        v-if="distributorFormInfo.enrollment_type === 'ADD'">
                                        将现有经销商移入辖区
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#FF9901;"
                                       v-if="distributorFormInfo.enrollment_type === 'NEW'">
                                        在辖区内添加新的经销商
                                    </p>
                                    <p style="margin:0;padding-left: 20px; font-size: 16px;color:#ED3B3F;"
                                        v-if="distributorFormInfo.enrollment_type === 'REMOVE'">
                                        将现有经销商移出辖区
                                    </p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" >
                                <el-form-item label="经销商名称">
                                    <p style="margin:0;padding-left: 20px;font-size: 16px;color:#4A90E2;">
                                        {{distributorFormInfo.distributor_name}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px" :model="form" style="font-size: 14px">
                                <el-form-item label="推广产品">
                                    <div style="padding-left: 20px">
                                        <span style="margin:0 10px 0px 0px;background: #FF9901;
                                    color: #fff;border-radius: 5px;padding: 0 10px;"
                                              v-for="(item,index) in distributorProductList">{{item.product_name}}</span>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form ref="form" label-width="120px"  style="font-size: 14px">
                                <el-form-item label="申请理由">
                                    <p style="margin:0;padding-left: 20px;color: #87909A;">{{distributorFormInfo.comments}}</p>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row class="HcpClass1">
                        <el-col>
                            <el-tabs v-model="activeName" >
                                <el-tab-pane label="基本信息" name="first">
                                    <el-row>
                                        <el-form ref="form" disabled label-width="120px" :model="distributorFormInfo"
                                                 style="font-size: 14px">
                                            <el-col :span="12">
                                                <el-form-item label="名称">
                                                    <el-input v-model="distributorFormInfo.distributor_name"
                                                              disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="编码">
                                                    <el-input v-model="distributorFormInfo.distributor_code" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="类别">
                                                    <el-input v-model="distributorFormInfo.type"></el-input>
<!--                                                    <el-select v-model="distributorFormInfo.institution_type" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsTypeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="级别">
                                                    <el-input v-model="distributorFormInfo.grade"></el-input>
<!--                                                    <el-select v-model="distributorFormInfo.institution_grade" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in institutionsGardeList"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="省份">
                                                    <el-input v-model="distributorFormInfo.province_name"></el-input>
<!--                                                    <el-select v-model="distributorFormInfo.province_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in ProvinceList"-->
<!--                                                                :key="item.province_id"-->
<!--                                                                :label="item.province_name"-->
<!--                                                                :value="item.province_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="城市">
                                                    <el-input v-model="distributorFormInfo.city_name"></el-input>
<!--                                                    <el-select v-model="distributorFormInfo.city_id" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in CityList"-->
<!--                                                                :key="item.city_id"-->
<!--                                                                :label="item.city_name"-->
<!--                                                                :value="item.city_id"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="地址">
                                                    <el-input v-model="distributorFormInfo.address" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="联系电话">
                                                    <el-input v-model="distributorFormInfo.telephone" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="邮政编码">
                                                    <el-input v-model="distributorFormInfo.postcode" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="官方网址">
                                                    <el-input v-model="distributorFormInfo.website" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="所属经销商">
                                                    <el-input
                                                            disabled
                                                            v-model="distributorFormInfo.distributor_name">

                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="开发进度">
                                                    <el-input v-model="distributorFormInfo.stage"></el-input>
<!--                                                    <el-select v-model="distributorFormInfo.agreement_stage" placeholder="" disabled style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in AGREEMENT_STAGE"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key"-->
<!--                                                        >-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="已进药">
                                                    <el-switch
                                                            v-model="distributorFormInfo.agreement_signed"
                                                            active-value="T"
                                                            inactive-value="F"
                                                            active-color="#13ce66"
                                                            disabled>
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo_D">
                                    <div class="subjectList" style="margin-top: 20px;">
                                        <el-form   :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item" :key="item.field_id">
                                            <el-col span="24" v-if="item.input_type == 'TEXT'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" disabled ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'DATE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-date-picker
                                                            v-model="item.field_value"
                                                            type="date"
                                                            placeholder=""
                                                            style="width: 100%"
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"
                                                            disabled>
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-switch
                                                            v-model="item.field_value"
                                                            active-color="#13ce66"
                                                            active-value="T"
                                                            inactive-value = "F"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
                                            <el-col span="24" v-else-if="item.input_type == 'LIST'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-cascader
                                                            v-model="item.field_value"
                                                            :options="item.listArray"
                                                            style="width: 100%"
                                                            filterable
                                                            disabled
                                                            placeholder=""
                                                            :show-all-levels="false"
                                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                                            clearable></el-cascader>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-table
                                                            :data="item.field_value"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                type="index"
                                                                label="序号"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="标准科室"
                                                                v-if="item.array_dept !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="product_name"
                                                                label="产品"
                                                                v-if="item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="sku_name"
                                                                label="SKU"
                                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="date_name"
                                                                label="日期"
                                                                v-if="item.array_date !== 'NONE' "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="field_value"
                                                                label="数值"
                                                        >
                                                        </el-table-column>

                                                    </el-table>
                                                </el-form-item>
                                            </el-col>

                                            <el-col span="24" v-else>
                                                <el-form-item :label="item.label"

                                                >
                                                    <el-input  :rows="3" v-model="item.field_value" placeholder="" type="textarea" disabled></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-form>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="签到位置" name="third">
                                    <div style="height: 300px">
                                        <el-amap
                                                vid="mapDemo3"
                                                :center="centerDistributor"
                                                :zoom="12"
                                                :plugin="plugin"
                                                class="amap-demo"
                                                style="position: relative;top: -63px;"
                                        >
                                            <el-amap-marker

                                                    :position="center.position"
                                                    :template="center.template"
                                                    :events="center.events"
                                                    v-for="center in centersDistributor">
                                            </el-amap-marker>
                                        </el-amap>
                                    </div>
                                    <div style="margin-top: 10px" class="amap">
                                        <el-form  :model="locationFormDistributor" label-width="80px">
                                            <el-form-item label="名称">
                                                <el-input v-model="locationFormDistributor.location_name" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="地址">
                                                <el-input v-model="locationFormDistributor.address" disabled></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>





    </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/css/swiper.min.css'
    import 'swiper/js/swiper.min.js'
    import http from '../../APIService/http'
    import BasicInfo from './components/basicInfo.vue'
    import imgUrl from "../../assets/images/mark_0.png";
    import moment from 'moment'
    export default {
        name: "jurmanageApproval",
        data(){
            return{
                markers2: [],
                plugin: [{
                    pName: 'ToolBar',
                    position:'RB',
                    locate:false,

                    events: {
                        init(instance) {

                        }
                    }

                }],
                mapCenter: [121.59996, 31.197646],
                searchOption: {
                    city: '上海',
                    citylimit: false
                },
                searchStr:"",
                activeName:'first',
                tableData: [],
                territory_name:'',
                territory_code:'',
                alias:null,

                storelist:{},
                Hcplist:{},
                business:{},
                HcplistActive: {
                    segment_id:'',
                    comments:'',
                    effective_date:'',
                    account_status:''
                },
                businessActive:{
                    segment_id:'',
                    comments:'',
                    effective:'',
                    account_status:''
                },
                storelistAction:{
                    segment_id:'',
                    account_status:'',
                    comments:'',
                    effective_date:''
                },
                listData:[],
                listData2:[],
                listData3:[],
                dialogVisible:false,
                dialogVisible2:false,
                dialogVisible3:false,
                radio1:'',
                role:'',
                tab:1,
                loading:false,
                form:{
                    TerritoryList:'',
                },
                checked:'',
                TerritoryList:[],
                // tableData:[],
                tableData2:[],
                tableData3:[],
                array:[],
                territoryArray:[],
                multipleSelection:[],
                accountArray:[],
                AGREEMENT_STAGE:[],
                key:'getApprovalHcpList',
                imgarr:[require('../../assets/images/wei.png'),require('../../assets/images/xuan.png')],
                institutionsFormInfo:{},
                retailstoreFormInfo:{},
                distributorFormInfo:{},
                extendedInfo:{},
                extendedInfo_S:{},
                extendedInfo_D:{},
                CityList:[],
                ProvinceList:[],
                institutionsTypeList:[],
                institutionsGardeList:[],
                institutionsLocations:[],

                center : [116.46, 39.92],
                centers:[],
                locationForm:{
                    location_name:'',
                    address:''
                },

                centerRetailstore : [116.46, 39.92],
                centersRetailstore:[],
                locationFormRetailstore:{
                    location_name:'',
                    address:''
                },

                centerDistributor : [116.46, 39.92],
                centersDistributor:[],
                locationFormDistributor:{
                    location_name:'',
                    address:''
                },

                institutionsProductList:[],
                retailstoreProductList:[],
                distributorProductList:[],
                tableRow:{},
                enrollment_id:'',
                enrollment_type:'',
                clientObj:{}
            }
        },
        components: {
            BasicInfo
        },
        created(){
            this.clientObj=this.$store.getters.getClient
            if(this.clientObj.showInstitution){
                this.radio1 = '医疗机构'
            }else if(!this.clientObj.showInstitution && this.clientObj.showStore){
                this.radio1 = '零售终端'
            }else if(!this.clientObj.showInstitution && !this.clientObj.showStore && this.clientObj.showDistributor){
                this.radio1 = '分销客户'
            }
            this.role=this.$store.getters.getUser.role
            this.getTerritoryList()



            // this.getDictionaryListByKOL_LEVEL2()
            // this.getProvinceList()
            // this.getCityList()
            // this.getItitutionTypeList()
            // this.getItitutionGardeList()
        },
        methods:{
            agree(){
                this.ApprovedAccount()
            },
            refuse(){
                this.DeniedAccount()
            },

            handleSelectionChange(value){
                this.accountArray=[]
                this.multipleSelection=[]
                this.multipleSelection=value
                for(var i=0;i<this.multipleSelection.length;i++){
                    let obj = {
                        enrollment_id:'',
                        enrollment_type:''
                    }
                    obj.enrollment_id = this.multipleSelection[i].enrollment_id
                    obj.enrollment_type = this.multipleSelection[i].enrollment_type

                    this.accountArray.push(obj)
                }

            },
            handleSelectionChange2(value){

                this.accountArray=[]
                this.multipleSelection=[]
                this.multipleSelection=value
                for(var i=0;i<this.multipleSelection.length;i++){
                    let obj = {
                        enrollment_id:'',
                        enrollment_type:''
                    }
                    obj.enrollment_id = this.multipleSelection[i].enrollment_id
                    obj.enrollment_type = this.multipleSelection[i].enrollment_type

                    this.accountArray.push(obj)
                }

            },
            handleSelectionChange3(value){

                this.accountArray=[]
                this.multipleSelection=[]
                this.multipleSelection=value
                for(var i=0;i<this.multipleSelection.length;i++){
                    let obj = {
                        enrollment_id:'',
                        enrollment_type:''
                    }
                    obj.enrollment_id = this.multipleSelection[i].enrollment_id
                    obj.enrollment_type = this.multipleSelection[i].enrollment_type

                    this.accountArray.push(obj)
                }

            },

            fangfa(item){

                if(item==='医疗机构'){
                    this.key='getApprovalHcpList'

                }else if(item==='零售终端'){

                    this.key='getApprovalRetailstoreList'


                }else if(item==='分销客户'){

                    this.key='getApprovalDistributorList'

                }
                this.getApprovalHcpList()
            },
            btn(row){
                this.activeName = 'first'
                this.enrollment_id = row.enrollment_id
                this.enrollment_type = row.enrollment_type
                this.getAccountInfoIns(row)
                this.dialogVisible=true
            },
            btn2(row){
                this.activeName = 'first'
                this.enrollment_id = row.enrollment_id
                this.enrollment_type = row.enrollment_type
                this.getAccountInfoStore(row)
                this.dialogVisible2=true
            },
            btn3(row){
                this.activeName = 'first'
                this.enrollment_id = row.enrollment_id
                this.enrollment_type = row.enrollment_type
                this.getAccountInfoDis(row)
                this.dialogVisible3=true
            },
            selectBack(item){
                if(this.radio1==='医疗机构'){
                    this.key='getApprovalHcpList'
                }else if(this.radio1==='零售终端'){
                    this.key='getApprovalRetailstoreList'
                }else if(this.radio1==='分销客户'){
                    this.key='getApprovalDistributorList'
                }
                for (var i = 0; i < this.array.length; i++){
                    this.array[i].isSelect = false
                }
                this.territoryArray=[]
                let a=item.territory_id
                this.territoryArray.push(a)
                item.isSelect = true

                this.territory_name=item.territory_name
                this.territory_code=item.territory_code
                this.alias=item.alias


                this.getApprovalHcpList()
                //this.getApprovalDistributorList()
                //this.getApprovalRetailstoreList()
            },

            // dianji(){
            //     this.$router.push({path:'/pending/lingshou'});
            // },
            // dianji2(){
            //     this.$router.push({path:'/pending/qudao'});
            // },
            dianji3(item){

//                item.isSelect = !item.isSelect
//                this.getApprovalHcpList()
                if(this.radio1==='医疗机构'){
                    this.key='getApprovalHcpList'
                }else if(this.radio1==='零售终端'){
                    this.key='getApprovalRetailstoreList'
                }else if(this.radio1==='分销客户'){
                    this.key='getApprovalDistributorList'
                }
                if(this.territoryArray.length === 0){
                    item.isSelect = true
                    this.territoryArray.push(item.territory_id)
                    this.getApprovalHcpList()
                    return
                }
                else {
                    var b=false
                    for (var i = 0; i < this.territoryArray.length; i++){
                        let territory_id = this.territoryArray[i]
                        if (territory_id == item.territory_id){
                            item.isSelect = false
                            this.territoryArray.splice(i,1)
                            b = true
                            this.getApprovalHcpList()
                            return
                        }
                    }
                    if (b === false) {
                        item.isSelect = true
                        this.territoryArray.push(item.territory_id)
                        this.getApprovalHcpList()
                        return
                    }
                }

            },
            dianji4(item){
                if(this.radio1==='医疗机构'){
                    this.key='getApprovalHcpList'
                }else if(this.radio1==='零售终端'){
                    this.key='getApprovalRetailstoreList'
                }else if(this.radio1==='分销客户'){
                    this.key='getApprovalDistributorList'
                }
                this.territoryArray=[]
                for(var i = 0;i<this.array.length;i++){
                    this.array[i].isSelect = item
                    if(item){
                        let a=this.array[i].territory_id
                        this.territoryArray.push(a)
                        this.territory_name=this.array[i].territory_name
                        this.territory_code=this.array[i].territory_code
                        this.alias=this.array[i].alias
                    }
                    else {
                        this.territoryArray=[]
                        this.territory_name=''
                        this.territory_code=''
                        this.alias=null
                    }
                }
                this.getApprovalHcpList()
            },
            xuanze(value,option){
                this.form.TerritoryList=value
                this.getApprovalListByTerritoryId()
            },
            async getTerritoryList(){


                let data = {
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id:this.$store.getters.getUser.tenant_id,

                }
                let self = this
                await http.post('/wapi/Territory/getTerritoryList',data).then(res => {


                    if (res.success) {
                        self.TerritoryList=res.data

                        for(var i=0;i<self.TerritoryList.length;i++){
                            let a = self.TerritoryList[i]
                            if (i == 0 && this.form.TerritoryList == '') {
                                this.form.TerritoryList = a.territory_id
                            }
                        }
                        this.getApprovalListByTerritoryId()
                    }else {
                        Message.error(res.message);
                    }
                })
            },

            async getApprovalListByTerritoryId(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        territory_id:this.form.TerritoryList
                    }
                    let self = this
                    await http.post('/wapi/territory_router/getApprovalListByTerritoryId',data).then(res => {

                        if (res.success) {

                            for(var i= 0;i<res.data.length;i++){
                                res.data[i].isSelect=false
                            }
                            self.array=res.data

                        }else {
                            loading.close()
                            Message.error(res.message);
                        }
                        this.$nextTick(()=>{
                            new Swiper('.swiper-container', {
                                slidesPerView:"auto",
                                freeMode : true,
                                navigation: {
                                    nextEl:'.you' ,
                                    prevEl:'.zuo',
                                },
                            });
                        })

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }


            },
            //获取辖区变更审批列表
            async getApprovalHcpList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.tableData=[]
                this.tableData2=[]
                this.tableData3=[]
                let data = {
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    territoryArray:this.territoryArray
                }
                let self = this
                let obj={
                    getApprovalHcpList:'/wapi/territory_router/getTerritoryApprovalList_institution',
                    getApprovalDistributorList:'/wapi/territory_router/getTerritoryApprovalList_distributor',
                    getApprovalRetailstoreList:'/wapi/territory_router/getTerritoryApprovalList_restailstore'
                }
                // obj['a']
                await http.post(obj[this.key],data).then(res => {
                    if (res.success) {
                        this.processTheData(res.data)   //处理返回的数据
                    }else {
                        this.$message({
                            type: 'error',
                            message: res.name
                        })
                    }
                })
                loading.close()
            },
            processTheData(data){
                for (let item of data){
                    item.submit_date = moment(item.created_date).format('YYYY年MM月DD日')


                    if (item.enrollment_type === 'REMOVE'){
                        item.enrollment_name = '移除辖区'
                        item.color = '#ED3B3F'
                    }else if(item.enrollment_type === 'ADD'){
                        item.enrollment_name = '移入辖区'
                        item.color = '#7ED321'
                    } else if (item.enrollment_type === 'NEW') {
                        item.enrollment_name = '添加新客户'
                        item.color = '#FF9901'
                    }else if (item.enrollment_type === 'LOCATION'){
                        item.enrollment_name = '签到位置'
                        item.color = '#d68af9'
                    }


                    if (item.reference_obj === "INSTITUTION") {
                        item.reference_name = '机构'
                    }else if (item.reference_obj === 'DISTRIBUTOR'){
                        item.reference_name = '经销商'
                    }else if (item.reference_obj === 'RETAILSTORE'){
                        item.reference_name = '门店'
                    }
                }

                this.tableData=data
                this.tableData2=data
                this.tableData3=data
            },


            //机构详情
            async getAccountInfoIns(row){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    enrollment_id:row.enrollment_id,
                    enrollment_type:row.enrollment_type,
                }
                await http.post('/wapi/territory_router/getTerritoryEnrollmentInfo_I',data).then(res => {
                    if (res.success) {
                        this.institutionsFormInfo = res.data[0]
                        this.institutionsFormInfo.enrollment_type = row.enrollment_type
                        this.institutionsFormInfo.comments = row.comments
                        this.getProductInstitutions(row)
                        this.getExtendedInfo(row)
                        this.getLocation(row)
                    }else {
                        Message.error(res.message);
                    }
                })
                loading.close()
            },
            //门店详情
            async getAccountInfoStore(row){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    enrollment_id:row.enrollment_id,
                    enrollment_type:row.enrollment_type,
                }
                await http.post('/wapi/territory_router/getTerritoryEnrollmentInfo_S',data).then(res => {

                    if (res.success) {
                        this.retailstoreFormInfo = res.data[0]
                        this.retailstoreFormInfo.enrollment_type = row.enrollment_type
                        this.retailstoreFormInfo.comments = row.comments

                         this.getProductRetailstore(row)
                        this.getExtendedInfo_S(row)
                        this.getLocation_S(row)
                    }else {
                        Message.error(res.message);
                    }
                })
                loading.close()
            },
            //经销商详情
            async getAccountInfoDis(row){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    enrollment_id:row.enrollment_id,
                    enrollment_type:row.enrollment_type,
                }
                await http.post('/wapi/territory_router/getTerritoryEnrollmentInfo_D',data).then(res => {

                    if (res.success) {
                        this.distributorFormInfo = res.data[0]
                        this.distributorFormInfo.enrollment_type = row.enrollment_type
                        this.distributorFormInfo.comments = row.comments

                        this.getProductDistributor(row)
                        this.getExtendedInfo_D(row)
                        this.getLocation_D(row)
                    }else {
                        Message.error(res.message);
                    }
                })
                loading.close()
            },
            //获取机构产品
            async getProductInstitutions(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:row.institution_id,
                    territory_id:row.territory_id,
                    enrollment_type:row.enrollment_type,
                    enrollment_id:row.enrollment_id,
                }
                await http.post('/wapi/territory_router/getProductInstitutions',data).then(res =>{
                    if (res.success) {
                        this.institutionsProductList = res.data
                    }else {
                    }
                })
            },
            //获取门店产品
            async getProductRetailstore(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    store_id:row.store_id,
                    territory_id:row.territory_id,
                    enrollment_type:row.enrollment_type,
                    enrollment_id:row.enrollment_id,
                }
                await http.post('/wapi/territory_router/getProductRetailstore',data).then(res =>{
                    if (res.success) {
                        this.retailstoreProductList = res.data
                    }else {
                    }
                })
            },
            //获取经销商产品
            async getProductDistributor(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:row.distributor_id,
                    territory_id:row.territory_id,
                    enrollment_type:row.enrollment_type,
                    enrollment_id:row.enrollment_id,
                }
                await http.post('/wapi/territory_router/getProductDistributor',data).then(res =>{
                    if (res.success) {
                        this.distributorProductList = res.data
                    }else {
                    }
                })
            },
            // 机构扩展信息
            async getExtendedInfo(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:row.institution_id,
                    enrollment_type:row.enrollment_type,
                }
                let httpSql = '/wapi/Institution/getExtendedInfo1'
                if (row.enrollment_type === 'NEW'){
                    httpSql = '/wapi/JurActive/getExtendedInfo'
                } else {
                    httpSql = '/wapi/Institution/getExtendedInfo1'
                }
                await http.post(httpSql,data).then(res =>{
                    if (res.success) {
                        this.extendedInfo = res.data
                        if(this.extendedInfo.length>0){
                            for(let i = 0;i<this.extendedInfo.length;i++){
                                this.extendedInfo[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }
                    }else {
                    }
                })
            },
            // 门店扩展信息
            async getExtendedInfo_S(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    store_id:row.store_id,
                    retailstore_id : row.store_id,
                    enrollment_type:row.enrollment_type,
                }
                let httpSql = '/wapi/Retailstore/getExtendedInfo'
                if (row.enrollment_type === 'NEW'){
                    httpSql = '/wapi/JurActive/getExtendedInfo1'
                } else {
                    httpSql = '/wapi/Retailstore/getExtendedInfo'
                }
                await http.post(httpSql,data).then(res =>{
                    if (res.success) {
                        this.extendedInfo_S = res.data
                        if(this.extendedInfo_S.length>0){
                            for(let i = 0;i<this.extendedInfo_S.length;i++){
                                this.extendedInfo_S[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }
                    }else {
                    }
                })
            },
            // 经销商扩展信息
            async getExtendedInfo_D(row){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:row.distributor_id,
                    enrollment_type:row.enrollment_type,
                }
                let httpSql = '/wapi/Distributor/getExtendedInfo'
                if (row.enrollment_type === 'NEW'){
                    httpSql = '/wapi/JurActive/getExtendedInfo2'
                } else {
                    httpSql = '/wapi/Distributor/getExtendedInfo'
                }
                await http.post(httpSql,data).then(res =>{
                    if (res.success) {
                        this.extendedInfo_D = res.data
                        if(this.extendedInfo_D.length>0){
                            for(let i = 0;i<this.extendedInfo_D.length;i++){
                                this.extendedInfo_D[i].fieldArray.forEach(item=>{
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                        item.field_value = [item.field_value]
                                    }
                                    if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TABLE" && item.field_value !== ''){
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if(item.input_type==="TABLE" && item.field_value === ''){
                                        item.field_value = []
                                    }
                                    if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                        item.field_value = 'F'
                                    }


                                })
                            }
                        }
                    }else {
                    }
                })
            },
            // 机构地址
            async getLocation(row){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:row.institution_id,
                    reference_obj:'INSTITUTION',
                    enrollment_type:row.enrollment_type,
                }
                this.center=[116.46, 39.92]
                this.centers = [];
                this.locationForm.location_name = ''
                this.locationForm.address = ''
                await http.post('/wapi/territory_router/getLocation',data).then(res=>{

                    if(res.success === true){
                        if(res.data.length>0){

                            this.center = [res.data[0].lng,res.data[0].lat]
                            this.locationForm.location_name = res.data[0].location_name
                            this.locationForm.address = res.data[0].address

                            for(let i=0;i<res.data.length;i++){
                                this.centers.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click: ()=>{
                                            this.locationForm.location_name = res.data[i].location_name
                                            this.locationForm.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.center= [116.46, 39.92];
                            this.centers = [];
                            this.locationForm.location_name = ''
                            this.locationForm.address = ''
                        }
                    }

                })

            },
            // 门店地址
            async getLocation_S(row){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:row.store_id,
                    reference_obj:'RETAILSTORE',
                    enrollment_type:row.enrollment_type,
                }
                this.centerRetailstore=[116.46, 39.92]
                this.centersRetailstore = [];
                this.locationFormRetailstore.location_name = ''
                this.locationFormRetailstore.address = ''
                await http.post('/wapi/territory_router/getLocation',data).then(res=>{

                    if(res.success === true){

                        if(res.data.length>0){
                            this.centerRetailstore = [res.data[0].lng,res.data[0].lat]
                            this.locationFormRetailstore.location_name = res.data[0].location_name
                            this.locationFormRetailstore.address = res.data[0].address

                            for(let i=0;i<res.data.length;i++){
                                this.centersRetailstore.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click: ()=>{
                                            this.locationFormRetailstore.location_name = res.data[i].location_name
                                            this.locationFormRetailstore.address = res.data[i].address

                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.centerRetailstore= [116.46, 39.92];
                            this.centersRetailstore = [];
                            this.locationFormRetailstore.location_name = ''
                            this.locationFormRetailstore.address = ''
                        }
                    }

                })

            },
            // 经销商地址
            async getLocation_D(row){
                let data = {
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    reference_id:row.distributor_id,
                    reference_obj:'DISTRIBUTOR',
                    enrollment_type:row.enrollment_type,
                }
                this.centerDistributor=[116.46, 39.92]
                this.centersDistributor = [];
                this.locationFormDistributor.location_name = ''
                this.locationFormDistributor.address = ''
                await http.post('/wapi/territory_router/getLocation',data).then(res=>{

                    if(res.success === true){
                        if(res.data.length>0){
                            this.centerDistributor = [res.data[0].lng,res.data[0].lat]
                            this.locationFormDistributor.location_name = res.data[0].location_name
                            this.locationFormDistributor.address = res.data[0].address

                            for(let i=0;i<res.data.length;i++){
                                this.centersDistributor.push({
                                    position: [res.data[i].lng, res.data[i].lat],
                                    events: {
                                        click: ()=>{
                                            this.locationFormDistributor.location_name = res.data[i].location_name
                                            this.locationFormDistributor.address = res.data[i].address
                                        }
                                    },
                                    template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i+1}</div>`
                                });
                            }
                        }else{
                            this.centerDistributor= [116.46, 39.92];
                            this.centersDistributor = [];
                            this.locationFormDistributor.location_name = ''
                            this.locationFormDistributor.address = ''
                        }
                    }

                })

            },
            //拒绝变更
            async DeniedAccount(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        accountArray:this.accountArray
                    }

                    await http.post('/wapi/territory_router/deniedTerritoryEnrollment',data).then(res => {

                        if (res.success) {
                            loading.close()
                            this.getApprovalHcpList()
                            this.$message({
                                type:'success',
                                message:'已拒绝'
                            })
//                        this.getApprovalRetailstoreList()
//                        this.getApprovalDistributorList()

                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }


            },
            //单个拒绝变更
            async DeniedAccount_Asingle(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let accountArray = []
                    let obj = {
                        enrollment_id:'',
                        enrollment_type:'',
                    }
                    obj.enrollment_id = this.enrollment_id
                    obj.enrollment_type = this.enrollment_type
                    accountArray.push(obj)
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        accountArray:accountArray
                    }

                    await http.post('/wapi/territory_router/deniedTerritoryEnrollment',data).then(res => {

                        if (res.success) {
                            loading.close()
                            this.getApprovalHcpList()
                            this.dialogVisible3 = false
                            this.dialogVisible2 = false
                            this.dialogVisible = false
                            this.$message({
                                type:'success',
                                message:'已拒绝'
                            })
                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            //同意变更
            async ApprovedAccount(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        accountArray:this.accountArray
                    }
                    await http.post('/wapi/territory_router/approvedTerritoryEnrollment',data).then(res => {

                        if (res.success) {
                            this.getApprovalHcpList()
                            this.$message({
                                type:'success',
                                message:'已同意'
                            })
                            loading.close()
                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            //单个同意变更
            async ApprovedAccount_Asingle(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let accountArray = []
                    let obj = {
                        enrollment_id:'',
                        enrollment_type:'',
                    }
                    obj.enrollment_id = this.enrollment_id
                    obj.enrollment_type = this.enrollment_type
                    accountArray.push(obj)
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        accountArray:accountArray
                    }
                    await http.post('/wapi/territory_router/approvedTerritoryEnrollment',data).then(res => {

                        if (res.success) {
                            loading.close()
                            this.getApprovalHcpList()
                            this.dialogVisible3 = false
                            this.dialogVisible2 = false
                            this.dialogVisible = false
                            this.$message({
                                type:'success',
                                message:'已同意'
                            })
                        }else {
                            Message.error(res.message);
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            //省份列表
            // async getProvinceList() {
            //     let self = this
            //     await http.post('/wapi/Province/getProvinceList').then(res => {
            //         if (res.success) {
            //             self.ProvinceList = res.data
            //
            //         } else {
            //
            //         }
            //     })
            //
            // },
            //城市
            // async getCityList(province_id) {
            //
            //     let data = {
            //         province_id: province_id
            //     }
            //     let self = this
            //     await http.post('/wapi/City/getCityList1', data).then(res => {
            //
            //         if (res.success) {
            //             self.CityList = res.data
            //         } else {
            //
            //         }
            //     })
            //
            // },
            //类别
            // async getItitutionTypeList() {
            //     let data = {
            //         tenant_id: this.$store.getters.getUser.tenant_id,
            //     }
            //
            //     let self = this
            //     await http.post('/wapi/Institution/getItitutionTypeList', data).then(res => {
            //
            //         if (res.success) {
            //             self.institutionsTypeList = res.data
            //
            //         } else {
            //
            //         }
            //     })
            // },
            // async getItitutionGardeList() {
            //     let data = {
            //         tenant_id: this.$store.getters.getUser.tenant_id
            //     }
            //     let self = this
            //     await http.post('/wapi/territory_router/getInstitutionsGardeList', data).then(res => {
            //
            //         if (res.success) {
            //
            //             self.institutionsGardeList = res.data
            //
            //         } else {
            //
            //         }
            //     })
            // },

            // async getDictionaryListByKOL_LEVEL2() {
            //     let data = {
            //         tenant_id: this.$store.getters.getUser.tenant_id,
            //         category: "INSTITUTION_AGREEMENT_STAGE"
            //     }
            //     let self = this
            //     await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {
            //
            //         if (res.success) {
            //             self.AGREEMENT_STAGE = res.data
            //
            //         } else {
            //
            //         }
            //
            //     })
            // },


        },

        computed:{

        },
        mounted(){

        },
        watch:{},
        updated() {

        }
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        height: 1000%;
        padding-bottom: 20px;
    }

</style>
<style scoped>
    .people >>> .el-form-item__label{
        font-size: 16px;
        color: #000000;
    }
    .businessClass >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }
    .HcpClass >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }
    .HcpClass1 >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }
    .box{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .swiper-container{

        width: 90%;
        height: 152px;
        background-color: #fff;
        display: flex;

    }
    .swiper-wrapper{
        height: 150px;
        width: 100%;
    }
    .swiper-slide{
        width: 400px ;
        margin-left: 10px;
        background-color: #fff;
        border: 1px solid #ededed;
        position: relative;
    }
</style>
<style>
    #div1{
        display: none;
    }
    #div2{
        display: none;
    }
    #div3{
        display: none;
    }
    .headerStyle2 > div {
        font-size: 14px;
        color: #585757;
        font-weight: bold;
    }

    .headerStyle2:nth-last-of-type(1) > div {
        color: #4A90E2;
    }
</style>





// WEBPACK FOOTER //
// src/pages/jurmanage/jurmanageApproval.vue